import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import Icon from '~/components/icon/icon';
import styles from './styles.css';

export const items = [
  {
    text: 'Logout',
    url: '/logout'
  }
];

export class ProfileDropDown extends Component {
  state = {
    isOpen: false
  };

  toggleIsOpen = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  renderItems() {
    const { breweries } = this.props;
    const returnItems = [];
    if (breweries.length > 1) {
      returnItems.push(
        <DropdownItem key="selectbrewery" className="pointer" onClick={() => this.props.history.push('/selectbrewery')}>
          <span>Change brewery</span>
        </DropdownItem>
      );
    }

    return returnItems.concat(
      items.map(item => (
        <DropdownItem key={item.url} className="pointer" onClick={() => this.props.history.push(item.url)}>
          <span>{item.text}</span>
        </DropdownItem>
      ))
    );
  }

  render() {
    const { brewery, profile } = this.props;

    return (
      <Dropdown
        isOpen={this.state.isOpen}
        toggle={this.toggleIsOpen}
        className={`flex ph0 ph3-l items-center ${styles.container}`}
      >
        <DropdownToggle className={`flex items-center b--transparent bg-transparent hover-inherit ${styles.toggle}`}>
          <Icon icon={profile.avatarIcon} className="stroke-white mr0 mr2-m mr2-l" />
          <div className={styles.details}>
            <span className="f6 db strong">
              {profile.firstName} {profile.lastName}
            </span>
            {brewery && <span className="f7 db">{brewery.name}</span>}
          </div>
        </DropdownToggle>
        <DropdownMenu right>{this.renderItems()}</DropdownMenu>
      </Dropdown>
    );
  }
}

function mapStateToProps(state) {
  return {
    breweries: state.breweries,
    brewery: state.brewery,
    profile: state.auth.profile
  };
}

export default connect(mapStateToProps)(withRouter(ProfileDropDown));



// WEBPACK FOOTER //
// ./src/containers/profileDropdown/profileDropdown.jsx